module.exports = __webpack_public_path__ + "img/realTime_black.e4f02ae0.png";